(() => {
  const drawer   = document.getElementById('drawer-nav');
  const burger   = document.getElementById('drawer-nav-burger');
  const backdrop = document.getElementById('drawer-nav-backdrop');
  if (!drawer || !burger) return;

  const closeBtn = drawer.querySelector('.drawer-nav__close');
  const col1     = drawer.querySelector('.drawer-nav__col--l1');
  const col2     = drawer.querySelector('.drawer-nav__col--l2');
  const col3     = drawer.querySelector('.drawer-nav__col--l3');

  const lvl1Btns  = col1 ? col1.querySelectorAll('.drawer-nav__link--l1.has-children') : [];
  const lvl2Btns  = col2 ? col2.querySelectorAll('.drawer-nav__link--l2.has-children') : [];
  const lvl2Lists = col2 ? col2.querySelectorAll('.drawer-nav__list--l2') : [];
  const lvl3Lists = col3 ? col3.querySelectorAll('.drawer-nav__list--l3') : [];

  let activeLvl1 = null;
  let activeLvl2 = null;

  /* ---- Move burger into main nav list as first item ------------ */
  function placeBurger() {
    const mainNavUl = document.querySelector('.main-nav');
    if (mainNavUl) {
      const li = document.createElement('li');
      li.className = 'drawer-nav-burger-li';
      li.appendChild(burger);
      mainNavUl.prepend(li);
      burger.classList.add('is-placed');
    }
  }
  placeBurger();

  /* ---- Open ---------------------------------------------------- */
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    backdrop.hidden = false;
    requestAnimationFrame(() => backdrop.classList.add('is-active'));
  }

  /* ---- Close --------------------------------------------------- */
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden', 'fixed');

    resetToLevel1();
    backdrop.classList.remove('is-active');
    setTimeout(() => { backdrop.hidden = true; }, 350);
  }

  /* ---- Reset helpers ------------------------------------------- */
  function clearActiveLvl1() {
    if (activeLvl1) {
      activeLvl1.classList.remove('is-active');
      activeLvl1.setAttribute('aria-expanded', 'false');
      activeLvl1 = null;
    }
  }

  function clearActiveLvl2() {
    if (activeLvl2) {
      activeLvl2.classList.remove('is-active');
      activeLvl2.setAttribute('aria-expanded', 'false');
      activeLvl2 = null;
    }
  }

  function hideLvl2() {
    lvl2Lists.forEach(l => { l.hidden = true; });
    if (col2) col2.classList.remove('is-active');
    drawer.classList.remove('stage-2', 'stage-3');
    clearActiveLvl2();
    hideLvl3();
  }

  function hideLvl3() {
    lvl3Lists.forEach(l => { l.hidden = true; });
    if (col3) col3.classList.remove('is-active');
    drawer.classList.remove('stage-3');
    clearActiveLvl2();
  }

  function resetToLevel1() {
    clearActiveLvl1();
    hideLvl2();
  }

  /* ---- Open drawer to a specific L1 index (for main nav) ------- */
  function openDrawerToLevel(idx) {
    resetToLevel1();

    const targetBtn = Array.from(lvl1Btns).find(
      btn => btn.dataset.idx === String(idx)
    );

    if (targetBtn) {
      targetBtn.classList.add('is-active');
      targetBtn.setAttribute('aria-expanded', 'true');
      activeLvl1 = targetBtn;

      lvl2Lists.forEach(list => {
        list.hidden = list.dataset.parent !== String(idx);
      });

      drawer.classList.add('stage-2');
      if (col2) col2.classList.add('is-active');
    }

    if (!drawer.classList.contains('is-open')) {
      openDrawer();
    }
  }

  /* ---- Level 1 -> 2 -------------------------------------------- */
  lvl1Btns.forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = btn.dataset.idx;

      if (activeLvl1 === btn) {
        resetToLevel1();
        return;
      }

      clearActiveLvl1();
      hideLvl3();

      btn.classList.add('is-active');
      btn.setAttribute('aria-expanded', 'true');
      activeLvl1 = btn;

      lvl2Lists.forEach(list => {
        list.hidden = list.dataset.parent !== idx;
      });

      drawer.classList.add('stage-2');
      drawer.classList.remove('stage-3');
      if (col2) col2.classList.add('is-active');
    });
  });

  /* ---- Level 2 -> 3 -------------------------------------------- */
  lvl2Btns.forEach(btn => {
    btn.addEventListener('click', () => {
      const { p1, idx } = btn.dataset;

      if (activeLvl2 === btn) {
        hideLvl3();
        return;
      }

      clearActiveLvl2();

      btn.classList.add('is-active');
      btn.setAttribute('aria-expanded', 'true');
      activeLvl2 = btn;

      lvl3Lists.forEach(list => {
        list.hidden = !(list.dataset.p1 === p1 && list.dataset.p2 === idx);
      });

      drawer.classList.add('stage-3');
      if (col3) col3.classList.add('is-active');
    });
  });

  /* ---- Main nav integration (desktop): intercept clicks -------- */
  function setupMainNavIntegration() {
    document.documentElement.classList.add('has-drawer-nav');

    const mainNavUl = document.querySelector('.main-nav');
    if (!mainNavUl) return;

    const navLis = Array.from(
      mainNavUl.querySelectorAll(':scope > li')
    ).filter(li => !li.classList.contains('drawer-nav-burger-li'));

    navLis.forEach((li, index) => {
      const details = li.querySelector(':scope > details');
      if (!details) return;

      const summary = details.querySelector(':scope > summary');
      const link = summary ? summary.querySelector('a') : null;

      function interceptClick(e) {
        if (!window.matchMedia('(min-width: 769px)').matches) return;

        e.preventDefault();
        e.stopPropagation();

        details.removeAttribute('open');
        details.classList.remove('is-open', 'is-closing');
        document.body.classList.remove('overflow-hidden', 'fixed');

        const overlay = document.querySelector('.js-overlay');
        if (overlay) {
          overlay.classList.remove('is-visible', 'overlay--nav');
        }

        if (drawer.classList.contains('is-open') && activeLvl1 &&
            activeLvl1.dataset.idx === String(index)) {
          closeDrawer();
        } else {
          openDrawerToLevel(index);
        }
      }

      if (link) link.addEventListener('click', interceptClick);
      if (summary) summary.addEventListener('click', interceptClick);
    });
  }
  setupMainNavIntegration();

  /* ---- Events -------------------------------------------------- */
  burger.addEventListener('click', () => {
    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* ---- Close on resize to mobile ------------------------------- */
  const mdQuery = window.matchMedia('(min-width: 769px)');
  mdQuery.addEventListener('change', e => {
    if (!e.matches && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
})();
